// extracted by mini-css-extract-plugin
module.exports = {"competitionSeasonPlayerStandingsContainer":"style_competitionSeasonPlayerStandingsContainer__hIyoE","selectWrapper":"style_selectWrapper__fKZ4i"};